import type { AutocompleteRenderInputParams } from '@mui/material';

type LegacyKeys = 'InputProps' | 'inputProps' | 'InputLabelProps';

interface AutocompleteInputSlotProps {
  params: Omit<AutocompleteRenderInputParams, LegacyKeys>;
  slotProps: {
    input: AutocompleteRenderInputParams['InputProps'];
    htmlInput: AutocompleteRenderInputParams['inputProps'];
    inputLabel: AutocompleteRenderInputParams['InputLabelProps'];
  };
}

// MUI v9 passes these as params.slotProps already; only this file changes on the bump.
export const autocompleteInputSlotProps = ({
  InputProps,
  inputProps,
  InputLabelProps,
  ...params
}: AutocompleteRenderInputParams): AutocompleteInputSlotProps => ({
  params,
  slotProps: {
    input: InputProps,
    htmlInput: inputProps,
    inputLabel: InputLabelProps,
  },
});
